<template>
<div style="display:none">

<svg
   width="1188"
   height="110"
   viewBox="0 0 1188 110"
   version="1.1"
   id="svg_panel"
   sodipodi:docname="panel.svg"
   inkscape:version="1.1 (c68e22c387, 2021-05-23)"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <sodipodi:namedview
     id="namedview7271"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:pageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     inkscape:document-units="px"
     showgrid="false"
     inkscape:zoom="1.28"
     inkscape:cx="700.39062"
     inkscape:cy="179.6875"
     inkscape:window-width="1440"
     inkscape:window-height="837"
     inkscape:window-x="-8"
     inkscape:window-y="-8"
     inkscape:window-maximized="1"
     inkscape:snap-bbox="true"
     inkscape:snap-global="true"
     inkscape:snap-nodes="true"
     inkscape:object-nodes="false"
     inkscape:snap-intersection-paths="true"
     inkscape:object-paths="true"
     inkscape:snap-others="true"
     inkscape:snap-smooth-nodes="true"
     inkscape:snap-midpoints="true"
     inkscape:snap-object-midpoints="false"
     inkscape:snap-center="false"
     inkscape:bbox-paths="true"
     inkscape:snap-grids="true"
     inkscape:snap-bbox-edge-midpoints="true"
     units="px"
     width="1188px"
     scale-x="1e-05"
     showguides="false"
     fit-margin-left="200"
     fit-margin-right="200"
     fit-margin-top="200"
     fit-margin-bottom="200"
     showborder="true"
     inkscape:current-layer="g135539"
     height="110px"
     inkscape:lockguides="false"
     inkscape:bbox-nodes="true" />
  <defs
     id="defs7266">
    <rect
       x="759.25635"
       y="-245.40607"
       width="79.130936"
       height="46.076241"
       id="rect100416" />
    <linearGradient
       id="linearGradient45980"
       inkscape:swatch="solid">
      <stop
         style="stop-color:#dcdcdc;stop-opacity:1;"
         offset="0"
         id="stop45978" />
    </linearGradient>
    <inkscape:path-effect
       effect="powerstroke"
       id="path-effect42143"
       is_visible="true"
       lpeversion="1"
       offset_points="0.6537329,14.085808"
       not_jump="true"
       sort_points="true"
       interpolator_type="CentripetalCatmullRom"
       interpolator_beta="0.75"
       start_linecap_type="zerowidth"
       linejoin_type="spiro"
       miter_limit="4"
       scale_width="1"
       end_linecap_type="zerowidth" />
    <inkscape:path-effect
       effect="simplify"
       id="path-effect42141"
       is_visible="true"
       lpeversion="1"
       steps="1"
       threshold="0.0032025118"
       smooth_angles="0"
       helper_size="0"
       simplify_individual_paths="false"
       simplify_just_coalesce="false"
       step="1" />
  </defs>
  <g
     inkscape:groupmode="layer"
     id="layer4"
     inkscape:label="??? 3"
     style="display:inline"
     sodipodi:insensitive="true">
    <path
       style="color:#000000;display:inline;fill:#444444;fill-opacity:1;stroke-width:1.15688;-inkscape-stroke:none"
       d="m 5,0 h 1178 c 2.77,0 5,2.453 5,5.5 v 99 c 0,3.047 -2.23,5.5 -5,5.5 H 5 c -2.77,0 -5,-2.453 -5,-5.5 V 5.5 C 0,2.453 2.23,0 5,0 Z"
       id="rect19383" />
    <rect
       style="display:inline;opacity:1;fill:#eeeeee;fill-opacity:1;stroke-width:1.08875"
       id="rect19431"
       width="1168"
       height="90"
       x="10"
       y="10"
       rx="0"
       ry="0" />
  </g>
  <g
     inkscape:label="??? 1"
     inkscape:groupmode="layer"
     id="layer1"
     style="display:inline">
    <g
       id="g135539">
      <g
         id="g131593"
         transform="matrix(0.99999221,0,0,1,-0.62137787,-1.6614169)">
        <g
           id="g123919"
           transform="translate(-366.32075,156.93564)">
          <rect
             style="fill:#000000;fill-opacity:1;stroke:#000000;stroke-width:0.369602;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
             id="rect123799"
             width="33.949482"
             height="59.612099"
             x="645.23669"
             y="-130.28323"
             rx="0"
             ry="0" />
          <g
             id="g123718"
             transform="matrix(0.9206856,0,0,1.000373,-250.0542,86.535606)">
            <rect
               style="fill:#cccccc;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
               id="rect123676"
               width="35.14674"
               height="56.513634"
               x="973.28143"
               y="-215.35628"
               rx="0.75753927"
               ry="1.8682165" />
            <g
               transform="matrix(0.86360096,0,0,0.90931027,354.0135,-236.82885)"
               id="g123696"
               style="fill:#333333;fill-opacity:1">
              <path
                 style="fill:#333333;fill-opacity:1;stroke:none;stroke-width:1.19203px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                 d="m 732.44718,25.969512 v -1.530273 h 9.95659 v 1.530273 h 2.96709 v 3.7207 h 6.03073 V 46.439239 H 723.44925 V 29.690212 h 6.03072 v -3.7207 z"
                 id="path123678"
                 sodipodi:nodetypes="ccccccccccccc" />
              <g
                 transform="matrix(0.59709788,0,-0.15930534,0.39294624,394.6375,112.59546)"
                 style="fill:#a0522d;fill-opacity:0.94902"
                 id="g123694">
                <rect
                   style="fill:#a0522d;fill-opacity:0.94902;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-672.01849"
                   y="-601.27802"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect123680" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.94902;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-666.02808"
                   y="-597.6001"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect123682" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.94902;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-678.00891"
                   y="-604.95593"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect123684" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.94902;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-689.98969"
                   y="-612.31177"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect123686" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.94902;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-701.97052"
                   y="-619.6676"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect123688" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.94902;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-683.99927"
                   y="-608.63385"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect123690" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.94902;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-695.9801"
                   y="-615.98969"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect123692" />
              </g>
            </g>
            <g
               id="g123716"
               transform="matrix(0.86360096,0,0,0.90931027,354.0135,-228.19018)"
               style="fill:#333333;fill-opacity:1">
              <path
                 style="fill:#333333;fill-opacity:1;stroke:none;stroke-width:1.19203px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                 d="M 732.44718,73.908527 V 75.4388 h 9.95659 v -1.530273 h 2.96709 v -3.7207 h 6.03073 V 53.4388 h -27.95234 v 16.749027 h 6.03072 v 3.7207 z"
                 id="path123698"
                 sodipodi:nodetypes="ccccccccccccc" />
              <g
                 id="g123714"
                 transform="matrix(-0.59709788,0,0.15930534,0.39294624,1080.2133,129.4208)"
                 style="fill:#a0522d;fill-opacity:0.94902">
                <rect
                   style="fill:#a0522d;fill-opacity:0.94902;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect123700"
                   width="1.0511378"
                   height="16.163235"
                   x="-672.01849"
                   y="-601.27802"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.94902;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect123702"
                   width="1.0511378"
                   height="16.163235"
                   x="-666.02808"
                   y="-597.6001"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.94902;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect123704"
                   width="1.0511378"
                   height="16.163235"
                   x="-678.00891"
                   y="-604.95593"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.94902;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect123706"
                   width="1.0511378"
                   height="16.163235"
                   x="-689.98969"
                   y="-612.31177"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.94902;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect123708"
                   width="1.0511378"
                   height="16.163235"
                   x="-701.97052"
                   y="-619.6676"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.94902;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect123710"
                   width="1.0511378"
                   height="16.163235"
                   x="-683.99927"
                   y="-608.63385"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.94902;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect123712"
                   width="1.0511378"
                   height="16.163235"
                   x="-695.9801"
                   y="-615.98969"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
              </g>
            </g>
          </g>
        </g>
        <text
           xml:space="preserve"
           style="font-weight:bold;font-size:14.0001px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold'"
           x="268.44092"
           y="23.130182"
           id="text125947"><tspan
             sodipodi:role="line"
             id="tspan125945"
             x="268.44092"
             y="23.130182"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14.0001px;font-family:Arial;-inkscape-font-specification:'Arial Bold'">Console</tspan></text>
        <text
           xml:space="preserve"
           style="font-weight:bold;font-size:14.0001px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold'"
           x="283.51248"
           y="99.252838"
           id="text129411"><tspan
             sodipodi:role="line"
             id="tspan129409"
             x="283.51248"
             y="99.252838"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14.0001px;font-family:Arial;-inkscape-font-specification:'Arial Bold'">Aux</tspan></text>
      </g>
      <g
         id="g112408"
         transform="matrix(1.0000034,0,0,1.0021651,-9.5473189e-4,-0.55570557)">
        <g
           id="g111204">
          <g
             id="g69436"
             transform="matrix(0.90744874,0,0,1,-319.36006,179.07873)">
            <rect
               style="fill:#000000;fill-opacity:1;stroke:#000000;stroke-width:0.387992;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
               id="rect69250"
               width="37.41201"
               height="59.612099"
               x="724.10321"
               y="-153.10339"
               rx="0"
               ry="0" />
            <g
               id="g69266"
               transform="matrix(0.93177998,0,0,1.0091721,34.582935,122.72463)">
              <rect
                 style="fill:#cccccc;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                 id="rect69252"
                 width="37.719997"
                 height="56"
                 x="741.21887"
                 y="-271.78595"
                 rx="0.81300223"
                 ry="1.8512369" />
              <g
                 id="g69258"
                 transform="matrix(0.25073063,0,0,0.24845039,533.54497,-212.85504)"
                 name="g0/1">
                <path
                   style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                   d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                   id="path69254"
                   sodipodi:nodetypes="ccccccccc" />
                <path
                   style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                   d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                   id="path69256"
                   sodipodi:nodetypes="ccccc" />
              </g>
              <g
                 id="g69264"
                 transform="matrix(0.25073063,0,0,-0.24845039,533.54497,-274.71686)"
                 name="g0/2">
                <path
                   style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                   d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                   id="path69260"
                   sodipodi:nodetypes="ccccccccc" />
                <path
                   style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                   d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                   id="path69262"
                   sodipodi:nodetypes="ccccc" />
              </g>
            </g>
          </g>
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.9848px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.952601"
             x="364.84479"
             y="22.689777"
             id="text69316"
             transform="scale(0.95260104,1.0497574)"><tspan
               sodipodi:role="line"
               x="364.84479"
               y="22.689777"
               id="tspan69314"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.9848px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:0.952601">P1</tspan></text>
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.9848px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.952601"
             x="364.84479"
             y="93.838913"
             id="text69320"
             transform="scale(0.95260104,1.0497574)"><tspan
               sodipodi:role="line"
               x="364.84479"
               y="93.838913"
               id="tspan69318"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.9848px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:0.952601">P2</tspan></text>
        </g>
        <g
           id="g112376">
          <g
             id="g111304"
             transform="matrix(0.90744874,0,0,1,-263.3505,179.07873)">
            <rect
               style="fill:#000000;fill-opacity:1;stroke:#000000;stroke-width:0.387992;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
               id="rect111286"
               width="37.41201"
               height="59.612099"
               x="724.10321"
               y="-153.10339"
               rx="0"
               ry="0" />
            <g
               id="g111302"
               transform="matrix(0.93177998,0,0,1.0091721,34.582935,122.72463)">
              <rect
                 style="fill:#cccccc;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                 id="rect111288"
                 width="37.719997"
                 height="56"
                 x="741.21887"
                 y="-271.78595"
                 rx="0.81300223"
                 ry="1.8512369" />
              <g
                 id="g111294"
                 transform="matrix(0.25073063,0,0,0.24845039,533.54497,-212.85504)"
                 name="g0/3">
                <path
                   style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                   d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                   id="path111290"
                   sodipodi:nodetypes="ccccccccc" />
                <path
                   style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                   d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                   id="path111292"
                   sodipodi:nodetypes="ccccc" />
              </g>
              <g
                 id="g111300"
                 transform="matrix(0.25073063,0,0,-0.24845039,533.54497,-274.71686)"
                 name="g0/4">
                <path
                   style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                   d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                   id="path111296"
                   sodipodi:nodetypes="ccccccccc" />
                <path
                   style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                   d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                   id="path111298"
                   sodipodi:nodetypes="ccccc" />
              </g>
            </g>
          </g>
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.9848px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.952601"
             x="423.64423"
             y="22.689777"
             id="text111308"
             transform="scale(0.95260104,1.0497574)"><tspan
               sodipodi:role="line"
               x="423.64423"
               y="22.689777"
               id="tspan111306"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.9848px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:0.952601">P3</tspan></text>
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.9848px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.952601"
             x="423.64423"
             y="93.838913"
             id="text111312"
             transform="scale(0.95260104,1.0497574)"><tspan
               sodipodi:role="line"
               x="423.64423"
               y="93.838913"
               id="tspan111310"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.9848px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:0.952601">P4</tspan></text>
        </g>
      </g>
      <g
         id="pon_block2"
         transform="matrix(0.99999468,0,0,1.0027261,0.00263131,-0.79599916)">
        <g
           id="g115388">
          <g
             id="g112649"
             transform="matrix(0.90744874,0,0,1,-207.5265,179.07873)">
            <rect
               style="fill:#000000;fill-opacity:1;stroke:#000000;stroke-width:0.387992;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
               id="rect112631"
               width="37.41201"
               height="59.612099"
               x="724.10321"
               y="-153.10339"
               rx="0"
               ry="0" />
            <g
               id="g112647"
               transform="matrix(0.93177998,0,0,1.0091721,34.582935,122.72463)">
              <rect
                 style="fill:#cccccc;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                 id="rect112633"
                 width="37.719997"
                 height="56"
                 x="741.21887"
                 y="-271.78595"
                 rx="0.81300223"
                 ry="1.8512369" />
              <g
                 id="g112639"
                 transform="matrix(0.25073063,0,0,0.24845039,533.54497,-212.85504)"
                 name="g0/5">
                <path
                   style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                   d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                   id="path112635"
                   sodipodi:nodetypes="ccccccccc" />
                <path
                   style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                   d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                   id="path112637"
                   sodipodi:nodetypes="ccccc" />
              </g>
              <g
                 id="g112645"
                 transform="matrix(0.25073063,0,0,-0.24845039,533.54497,-274.71686)"
                 name="g0/6">
                <path
                   style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                   d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                   id="path112641"
                   sodipodi:nodetypes="ccccccccc" />
                <path
                   style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                   d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                   id="path112643"
                   sodipodi:nodetypes="ccccc" />
              </g>
            </g>
          </g>
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.981px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.952601"
             x="482.2457"
             y="22.689777"
             id="text112653"
             transform="scale(0.95260104,1.0497574)"><tspan
               sodipodi:role="line"
               x="482.2457"
               y="22.689777"
               id="tspan112651"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.981px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:0.952601">P5</tspan></text>
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.981px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.952601"
             x="482.2457"
             y="93.838913"
             id="text112657"
             transform="scale(0.95260104,1.0497574)"><tspan
               sodipodi:role="line"
               x="482.2457"
               y="93.838913"
               id="tspan112655"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.981px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:0.952601">P6</tspan></text>
        </g>
        <g
           id="g115404">
          <g
             id="g112679"
             transform="matrix(0.90744874,0,0,1,-151.51694,179.07873)">
            <rect
               style="fill:#000000;fill-opacity:1;stroke:#000000;stroke-width:0.387992;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
               id="rect112661"
               width="37.41201"
               height="59.612099"
               x="724.10321"
               y="-153.10339"
               rx="0"
               ry="0" />
            <g
               id="g112677"
               transform="matrix(0.93177998,0,0,1.0091721,34.582935,122.72463)">
              <rect
                 style="fill:#cccccc;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                 id="rect112663"
                 width="37.719997"
                 height="56"
                 x="741.21887"
                 y="-271.78595"
                 rx="0.81300223"
                 ry="1.8512369" />
              <g
                 id="g112669"
                 transform="matrix(0.25073063,0,0,0.24845039,533.54497,-212.85504)"
                 name="g0/7">
                <path
                   style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                   d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                   id="path112665"
                   sodipodi:nodetypes="ccccccccc" />
                <path
                   style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                   d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                   id="path112667"
                   sodipodi:nodetypes="ccccc" />
              </g>
              <g
                 id="g112675"
                 transform="matrix(0.25073063,0,0,-0.24845039,533.54497,-274.71686)"
                 name="g0/8">
                <path
                   style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                   d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                   id="path112671"
                   sodipodi:nodetypes="ccccccccc" />
                <path
                   style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                   d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                   id="path112673"
                   sodipodi:nodetypes="ccccc" />
              </g>
            </g>
          </g>
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.981px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.952601"
             x="541.04175"
             y="22.689777"
             id="text112683"
             transform="scale(0.95260104,1.0497574)"><tspan
               sodipodi:role="line"
               x="541.04175"
               y="22.689777"
               id="tspan112681"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.981px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:0.952601">P7</tspan></text>
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.981px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.952601"
             x="541.04175"
             y="93.838913"
             id="text112687"
             transform="scale(0.95260104,1.0497574)"><tspan
               sodipodi:role="line"
               x="541.04175"
               y="93.838913"
               id="tspan112685"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.981px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:0.952601">P8</tspan></text>
        </g>
      </g>
      <g
         id="pon_block3"
         transform="translate(0,-0.52755881)">
        <g
           id="g120168">
          <g
             id="g112744"
             transform="matrix(0.90744874,0,0,1,-95.6835,179.07873)">
            <rect
               style="fill:#000000;fill-opacity:1;stroke:#000000;stroke-width:0.387992;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
               id="rect112726"
               width="37.41201"
               height="59.612099"
               x="724.10321"
               y="-153.10339"
               rx="0"
               ry="0" />
            <g
               id="g112742"
               transform="matrix(0.93177998,0,0,1.0091721,34.582935,122.72463)">
              <rect
                 style="fill:#cccccc;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                 id="rect112728"
                 width="37.719997"
                 height="56"
                 x="741.21887"
                 y="-271.78595"
                 rx="0.81300223"
                 ry="1.8512369" />
              <g
                 id="g112734"
                 transform="matrix(0.25073063,0,0,0.24845039,533.54497,-212.85504)"
                 name="g0/9">
                <path
                   style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                   d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                   id="path112730"
                   sodipodi:nodetypes="ccccccccc" />
                <path
                   style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                   d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                   id="path112732"
                   sodipodi:nodetypes="ccccc" />
              </g>
              <g
                 id="g112740"
                 transform="matrix(0.25073063,0,0,-0.24845039,533.54497,-274.71686)"
                 name="g0/10">
                <path
                   style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                   d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                   id="path112736"
                   sodipodi:nodetypes="ccccccccc" />
                <path
                   style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                   d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                   id="path112738"
                   sodipodi:nodetypes="ccccc" />
              </g>
            </g>
          </g>
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.952601"
             x="599.65076"
             y="22.689777"
             id="text112748"
             transform="scale(0.95260104,1.0497574)"><tspan
               sodipodi:role="line"
               x="599.65076"
               y="22.689777"
               id="tspan112746"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:0.952601">P9</tspan></text>
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.952601"
             x="594.63574"
             y="93.838913"
             id="text112752"
             transform="scale(0.95260104,1.0497574)"><tspan
               sodipodi:role="line"
               x="594.63574"
               y="93.838913"
               id="tspan112750"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:0.952601">P10</tspan></text>
        </g>
        <g
           id="g120184">
          <g
             id="g112774"
             transform="matrix(0.90744874,0,0,1,-39.67394,179.07873)">
            <rect
               style="fill:#000000;fill-opacity:1;stroke:#000000;stroke-width:0.387992;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
               id="rect112756"
               width="37.41201"
               height="59.612099"
               x="724.10321"
               y="-153.10339"
               rx="0"
               ry="0" />
            <g
               id="g112772"
               transform="matrix(0.93177998,0,0,1.0091721,34.582935,122.72463)">
              <rect
                 style="fill:#cccccc;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                 id="rect112758"
                 width="37.719997"
                 height="56"
                 x="741.21887"
                 y="-271.78595"
                 rx="0.81300223"
                 ry="1.8512369" />
              <g
                 id="g112764"
                 transform="matrix(0.25073063,0,0,0.24845039,533.54497,-212.85504)"
                 name="g0/11">
                <path
                   style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                   d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                   id="path112760"
                   sodipodi:nodetypes="ccccccccc" />
                <path
                   style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                   d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                   id="path112762"
                   sodipodi:nodetypes="ccccc" />
              </g>
              <g
                 id="g112770"
                 transform="matrix(0.25073063,0,0,-0.24845039,533.54497,-274.71686)"
                 name="g0/12">
                <path
                   style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                   d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                   id="path112766"
                   sodipodi:nodetypes="ccccccccc" />
                <path
                   style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                   d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                   id="path112768"
                   sodipodi:nodetypes="ccccc" />
              </g>
            </g>
          </g>
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.952601"
             x="655.53485"
             y="22.689777"
             id="text112778"
             transform="scale(0.95260104,1.0497574)"><tspan
               sodipodi:role="line"
               x="655.53485"
               y="22.689777"
               id="tspan112776"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:0.952601">P11</tspan></text>
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.952601"
             x="653.43536"
             y="93.838913"
             id="text112782"
             transform="scale(0.95260104,1.0497574)"><tspan
               sodipodi:role="line"
               x="653.43536"
               y="93.838913"
               id="tspan112780"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:0.952601">P12</tspan></text>
        </g>
      </g>
      <g
         id="pon_block4"
         transform="translate(0,-0.52755881)">
        <g
           id="g120200">
          <g
             id="g112806"
             transform="matrix(0.90744874,0,0,1,16.1585,179.07873)">
            <rect
               style="fill:#000000;fill-opacity:1;stroke:#000000;stroke-width:0.387992;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
               id="rect112788"
               width="37.41201"
               height="59.612099"
               x="724.10321"
               y="-153.10339"
               rx="0"
               ry="0" />
            <g
               id="g112804"
               transform="matrix(0.93177998,0,0,1.0091721,34.582935,122.72463)">
              <rect
                 style="fill:#cccccc;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                 id="rect112790"
                 width="37.719997"
                 height="56"
                 x="741.21887"
                 y="-271.78595"
                 rx="0.81300223"
                 ry="1.8512369" />
              <g
                 id="g112796"
                 transform="matrix(0.25073063,0,0,0.24845039,533.54497,-212.85504)"
                 name="g0/13">
                <path
                   style="color:#000000;fill:#333330;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                   d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                   id="path112792"
                   sodipodi:nodetypes="ccccccccc" />
                <path
                   style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                   d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                   id="path112794"
                   sodipodi:nodetypes="ccccc" />
              </g>
              <g
                 id="g112802"
                 transform="matrix(0.25073063,0,0,-0.24845039,533.54497,-274.71686)"
                 name="g0/14">
                <path
                   style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                   d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                   id="path112798"
                   sodipodi:nodetypes="ccccccccc" />
                <path
                   style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                   d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                   id="path112800"
                   sodipodi:nodetypes="ccccc" />
              </g>
            </g>
          </g>
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.952601"
             x="712.04456"
             y="22.689777"
             id="text112810"
             transform="scale(0.95260104,1.0497574)"><tspan
               sodipodi:role="line"
               x="712.04456"
               y="22.689777"
               id="tspan112808"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:0.952601">P13</tspan></text>
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.952601"
             x="712.04456"
             y="93.838913"
             id="text112814"
             transform="scale(0.95260104,1.0497574)"><tspan
               sodipodi:role="line"
               x="712.04456"
               y="93.838913"
               id="tspan112812"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:0.952601">P14</tspan></text>
        </g>
        <g
           id="g120216">
          <g
             id="g112836"
             transform="matrix(0.90744874,0,0,1,72.16806,179.07873)">
            <rect
               style="fill:#000000;fill-opacity:1;stroke:#000000;stroke-width:0.387992;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
               id="rect112818"
               width="37.41201"
               height="59.612099"
               x="724.10321"
               y="-153.10339"
               rx="0"
               ry="0" />
            <g
               id="g112834"
               transform="matrix(0.93177998,0,0,1.0091721,34.582935,122.72463)">
              <rect
                 style="fill:#cccccc;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                 id="rect112820"
                 width="37.719997"
                 height="56"
                 x="741.21887"
                 y="-271.78595"
                 rx="0.81300223"
                 ry="1.8512369" />
              <g
                 id="g112826"
                 transform="matrix(0.25073063,0,0,0.24845039,533.54497,-212.85504)"
                 name="g0/15">
                <path
                   style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                   d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                   id="path112822"
                   sodipodi:nodetypes="ccccccccc" />
                <path
                   style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                   d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                   id="path112824"
                   sodipodi:nodetypes="ccccc" />
              </g>
              <g
                 id="g112832"
                 transform="matrix(0.25073063,0,0,-0.24845039,533.54497,-274.71686)"
                 name="g0/16">
                <path
                   style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                   d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                   id="path112828"
                   sodipodi:nodetypes="ccccccccc" />
                <path
                   style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                   d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                   id="path112830"
                   sodipodi:nodetypes="ccccc" />
              </g>
            </g>
          </g>
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.952601"
             x="770.84021"
             y="22.689777"
             id="text112840"
             transform="scale(0.95260104,1.0497574)"><tspan
               sodipodi:role="line"
               x="770.84021"
               y="22.689777"
               id="tspan112838"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:0.952601">P15</tspan></text>
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.952601"
             x="770.84021"
             y="93.838913"
             id="text112844"
             transform="scale(0.95260104,1.0497574)"><tspan
               sodipodi:role="line"
               x="770.84021"
               y="93.838913"
               id="tspan112842"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:0.952601">P16</tspan></text>
        </g>
      </g>
      <g
         id="g7960">
        <g
           id="g7892">
          <rect
             style="fill:#000000;fill-opacity:1;stroke:#000000;stroke-width:0.530241;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
             id="rect61579"
             width="69.469849"
             height="59.95853"
             x="785.16534"
             y="25.366045"
             rx="0"
             ry="0" />
          <g
             id="g7797">
            <rect
               style="fill:#cccccc;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
               id="rect61581"
               width="32.358135"
               height="56.997215"
               x="786.1272"
               y="26.84672"
               rx="0.69743472"
               ry="1.8842026" />
            <g
               id="g61587"
               transform="matrix(0.21508951,0,0,0.25287465,607.97395,86.827035)"
               name="e1/1_sfp">
              <path
                 style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                 d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                 id="path61583"
                 sodipodi:nodetypes="ccccccccc" />
              <path
                 style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                 d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                 id="path61585"
                 sodipodi:nodetypes="ccccc" />
            </g>
            <g
               id="g61593"
               transform="matrix(0.21508951,0,0,-0.25287465,607.97395,23.863617)"
               name="e1/2_sfp">
              <path
                 style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                 d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                 id="path61589"
                 sodipodi:nodetypes="ccccccccc" />
              <path
                 style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                 d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                 id="path61591"
                 sodipodi:nodetypes="ccccc" />
            </g>
          </g>
          <g
             id="g7788">
            <rect
               style="fill:#cccccc;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
               id="rect61597"
               width="32.358139"
               height="56.997215"
               x="820.9314"
               y="26.846661"
               rx="0.69743478"
               ry="1.8842026" />
            <g
               transform="matrix(0.79508138,0,0,0.91709115,250.79724,5.1903492)"
               id="g61617"
               name="e1/1">
              <path
                 style="fill:#333333;fill-opacity:1;stroke:none;stroke-width:1.19203px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                 d="m 732.44718,25.969512 v -1.530273 h 9.95659 v 1.530273 h 2.96709 v 3.7207 h 6.03073 V 46.439239 H 723.44925 V 29.690212 h 6.03072 v -3.7207 z"
                 id="path61599"
                 sodipodi:nodetypes="ccccccccccccc" />
              <g
                 transform="matrix(0.59709788,0,-0.15930534,0.39294624,394.6375,112.59546)"
                 style="fill:#a0522d"
                 id="g61615">
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-672.01849"
                   y="-601.27802"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect61601" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-666.02808"
                   y="-597.6001"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect61603" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-678.00891"
                   y="-604.95593"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect61605" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-689.98969"
                   y="-612.31177"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect61607" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-701.97052"
                   y="-619.6676"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect61609" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-683.99927"
                   y="-608.63385"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect61611" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-695.9801"
                   y="-615.98969"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect61613" />
              </g>
            </g>
            <g
               id="g61637"
               transform="matrix(0.79508138,0,0,0.91709115,250.79724,13.902939)"
               name="e1/2">
              <path
                 style="fill:#333333;fill-opacity:1;stroke:none;stroke-width:1.19203px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                 d="M 732.44718,73.908527 V 75.4388 h 9.95659 v -1.530273 h 2.96709 v -3.7207 h 6.03073 V 53.4388 h -27.95234 v 16.749027 h 6.03072 v 3.7207 z"
                 id="path61619"
                 sodipodi:nodetypes="ccccccccccccc" />
              <g
                 id="g61635"
                 transform="matrix(-0.59709788,0,0.15930534,0.39294624,1080.2133,129.4208)"
                 style="fill:#a0522d">
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect61621"
                   width="1.0511378"
                   height="16.163235"
                   x="-672.01849"
                   y="-601.27802"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect61623"
                   width="1.0511378"
                   height="16.163235"
                   x="-666.02808"
                   y="-597.6001"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect61625"
                   width="1.0511378"
                   height="16.163235"
                   x="-678.00891"
                   y="-604.95593"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect61627"
                   width="1.0511378"
                   height="16.163235"
                   x="-689.98969"
                   y="-612.31177"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect61629"
                   width="1.0511378"
                   height="16.163235"
                   x="-701.97052"
                   y="-619.6676"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect61631"
                   width="1.0511378"
                   height="16.163235"
                   x="-683.99927"
                   y="-608.63385"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect61633"
                   width="1.0511378"
                   height="16.163235"
                   x="-695.9801"
                   y="-615.98969"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
              </g>
            </g>
          </g>
        </g>
        <g
           id="g7898">
          <path
             style="fill:none;stroke:#000000;stroke-width:0.2;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;stroke-miterlimit:4;stroke-dasharray:none"
             d="m 831.49607,17.093506 h 6.00903 v 3.777841"
             id="path7532" />
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.00407"
             x="813.37958"
             y="22.76943"
             id="text61645"
             transform="scale(0.99591976,1.004097)"><tspan
               sodipodi:role="line"
               x="813.37958"
               y="22.76943"
               id="tspan61643"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:1.00407">G1</tspan></text>
          <path
             style="fill:none;stroke:#000000;stroke-width:0.170566px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
             d="m 807.59002,17.093506 h -6.00903 v 3.777841"
             id="path7646" />
        </g>
        <g
           id="g7910"
           transform="translate(-0.350637)">
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.00407"
             x="813.37958"
             y="97.765129"
             id="text61649"
             transform="scale(0.99591976,1.004097)"><tspan
               sodipodi:role="line"
               x="813.37958"
               y="97.765129"
               id="tspan61647"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:1.00407">G2</tspan></text>
          <path
             style="fill:none;stroke:#000000;stroke-width:0.170566px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
             d="m 831.46193,92.596739 h 6.00903 v -3.777841"
             id="path7650" />
          <path
             style="fill:none;stroke:#000000;stroke-width:0.170566px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
             d="m 807.94095,92.596739 h -6.00903 v -3.777841"
             id="path7656" />
        </g>
      </g>
      <g
         id="g8004">
        <g
           id="g100484"
           transform="matrix(0.92065623,0,0,1.0091752,155.04716,4.8710039)">
          <rect
             style="fill:#000000;fill-opacity:1;stroke:#000000;stroke-width:0.550267;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
             id="rect100422"
             width="75.456711"
             height="59.449825"
             x="784.18115"
             y="20.264473"
             rx="0"
             ry="0" />
          <g
             id="g100438"
             transform="matrix(0.93177998,0,0,1.0091721,94.573002,296.01137)">
            <rect
               style="fill:#cccccc;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
               id="rect100424"
               width="37.719997"
               height="56"
               x="741.21887"
               y="-271.78595"
               rx="0.81300223"
               ry="1.8512369" />
            <g
               id="g100430"
               transform="matrix(0.25073063,0,0,0.24845039,533.54497,-212.85504)"
               name="e1/3_sfp">
              <path
                 style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                 d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                 id="path100426"
                 sodipodi:nodetypes="ccccccccc" />
              <path
                 style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                 d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                 id="path100428"
                 sodipodi:nodetypes="ccccc" />
            </g>
            <g
               id="g100436"
               transform="matrix(0.25073063,0,0,-0.24845039,533.54497,-274.71686)"
               name="e1/4_sfp">
              <path
                 style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                 d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                 id="path100432"
                 sodipodi:nodetypes="ccccccccc" />
              <path
                 style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                 d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                 id="path100434"
                 sodipodi:nodetypes="ccccc" />
            </g>
          </g>
          <g
             id="g100482"
             transform="translate(-150.25193,237.08882)">
            <rect
               style="fill:#cccccc;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
               id="rect100440"
               width="35.14674"
               height="56.513634"
               x="973.28143"
               y="-215.35628"
               rx="0.75753927"
               ry="1.8682165" />
            <g
               transform="matrix(0.86360096,0,0,0.90931027,354.0135,-236.82885)"
               id="g100460"
               name="e1/3">
              <path
                 style="fill:#333333;fill-opacity:1;stroke:none;stroke-width:1.19203px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                 d="m 732.44718,25.969512 v -1.530273 h 9.95659 v 1.530273 h 2.96709 v 3.7207 h 6.03073 V 46.439239 H 723.44925 V 29.690212 h 6.03072 v -3.7207 z"
                 id="path100442"
                 sodipodi:nodetypes="ccccccccccccc" />
              <g
                 transform="matrix(0.59709788,0,-0.15930534,0.39294624,394.6375,112.59546)"
                 style="fill:#a0522d"
                 id="g100458">
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-672.01849"
                   y="-601.27802"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect100444" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-666.02808"
                   y="-597.6001"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect100446" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-678.00891"
                   y="-604.95593"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect100448" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-689.98969"
                   y="-612.31177"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect100450" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-701.97052"
                   y="-619.6676"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect100452" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-683.99927"
                   y="-608.63385"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect100454" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   width="1.0511378"
                   height="16.163235"
                   x="-695.9801"
                   y="-615.98969"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
                   id="rect100456" />
              </g>
            </g>
            <g
               id="g100480"
               transform="matrix(0.86360096,0,0,0.90931027,354.0135,-228.19018)"
               name="e1/4">
              <path
                 style="fill:#333333;fill-opacity:1;stroke:none;stroke-width:1.19203px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                 d="M 732.44718,73.908527 V 75.4388 h 9.95659 v -1.530273 h 2.96709 v -3.7207 h 6.03073 V 53.4388 h -27.95234 v 16.749027 h 6.03072 v 3.7207 z"
                 id="path100462"
                 sodipodi:nodetypes="ccccccccccccc" />
              <g
                 id="g100478"
                 transform="matrix(-0.59709788,0,0.15930534,0.39294624,1080.2133,129.4208)"
                 style="fill:#a0522d">
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect100464"
                   width="1.0511378"
                   height="16.163235"
                   x="-672.01849"
                   y="-601.27802"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect100466"
                   width="1.0511378"
                   height="16.163235"
                   x="-666.02808"
                   y="-597.6001"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect100468"
                   width="1.0511378"
                   height="16.163235"
                   x="-678.00891"
                   y="-604.95593"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect100470"
                   width="1.0511378"
                   height="16.163235"
                   x="-689.98969"
                   y="-612.31177"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect100472"
                   width="1.0511378"
                   height="16.163235"
                   x="-701.97052"
                   y="-619.6676"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect100474"
                   width="1.0511378"
                   height="16.163235"
                   x="-683.99927"
                   y="-608.63385"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
                <rect
                   style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
                   id="rect100476"
                   width="1.0511378"
                   height="16.163235"
                   x="-695.9801"
                   y="-615.98969"
                   rx="0.11332455"
                   ry="1.0626545"
                   transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
              </g>
            </g>
          </g>
        </g>
        <g
           id="g7904"
           transform="translate(-0.245407)">
          <path
             style="fill:none;stroke:#000000;stroke-width:0.170566px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
             d="m 923.86289,17.093157 h 6.00903 v 3.777841"
             id="path7652" />
          <path
             style="fill:none;stroke:#000000;stroke-width:0.170566px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
             d="m 900.13072,17.093506 h -6.00903 v 3.777841"
             id="path7658" />
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.00437"
             x="905.87695"
             y="22.716459"
             id="text100488"
             transform="scale(0.99561349,1.0044058)"><tspan
               sodipodi:role="line"
               x="905.87695"
               y="22.716459"
               id="tspan100486"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:1.00437">G3</tspan></text>
        </g>
        <g
           id="g7916">
          <path
             style="fill:none;stroke:#000000;stroke-width:0.170566px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
             d="m 924.5989,92.596739 h 6.00903 v -3.777841"
             id="path7648" />
          <path
             style="fill:none;stroke:#000000;stroke-width:0.170566px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
             d="m 899.88539,92.596739 h -6.00904 v -3.777841"
             id="path7654" />
          <text
             xml:space="preserve"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.00437"
             x="905.87695"
             y="97.735062"
             id="text100492"
             transform="scale(0.99561349,1.0044058)"><tspan
               sodipodi:role="line"
               x="905.87695"
               y="97.735062"
               id="tspan100490"
               style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:14px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:1.00437">G4</tspan></text>
        </g>
      </g>
      <g
         id="g122848"
         transform="matrix(0.99998884,0,0,1.0021651,0.01100387,-0.55570537)">
        <g
           id="g120644"
           transform="matrix(0.90744874,0,0,1,311.6855,179.07873)">
          <rect
             style="fill:#000000;fill-opacity:1;stroke:#000000;stroke-width:0.387992;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
             id="rect120626"
             width="37.41201"
             height="59.612099"
             x="724.10321"
             y="-153.10339"
             rx="0"
             ry="0" />
          <g
             id="g120642"
             transform="matrix(0.93177998,0,0,1.0091721,34.582935,122.72463)">
            <rect
               style="fill:#cccccc;fill-opacity:1;stroke:#000000;stroke-width:0;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
               id="rect120628"
               width="37.719997"
               height="56"
               x="741.21887"
               y="-271.78595"
               rx="0.81300223"
               ry="1.8512369" />
            <g
               id="g120634"
               transform="matrix(0.25073063,0,0,0.24845039,533.54497,-212.85504)"
               name="e2/1">
              <path
                 style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                 d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                 id="path120630"
                 sodipodi:nodetypes="ccccccccc" />
              <path
                 style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                 d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                 id="path120632"
                 sodipodi:nodetypes="ccccc" />
            </g>
            <g
               id="g120640"
               transform="matrix(0.25073063,0,0,-0.24845039,533.54497,-274.71686)"
               name="e2/2">
              <path
                 style="color:#000000;fill:#333333;fill-opacity:1;stroke-width:1.48803;-inkscape-stroke:none"
                 d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
                 id="path120636"
                 sodipodi:nodetypes="ccccccccc" />
              <path
                 style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
                 d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
                 id="path120638"
                 sodipodi:nodetypes="ccccc" />
            </g>
          </g>
        </g>
        <text
           xml:space="preserve"
           style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.9849px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.952601"
           x="1022.2161"
           y="22.689777"
           id="text120648"
           transform="scale(0.95260104,1.0497574)"><tspan
             sodipodi:role="line"
             x="1022.2161"
             y="22.689777"
             id="tspan120646"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.9849px;font-family:Arial;-inkscape-font-specification:'Arial Bold';stroke-width:0.952601">XG1</tspan></text>
        <text
           xml:space="preserve"
           style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.9849px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.952601"
           x="1035.5414"
           y="93.838913"
           id="text120652"
           transform="scale(0.95260104,1.0497574)"><tspan
             sodipodi:role="line"
             x="1035.5414"
             y="93.838913"
             id="tspan120650"
             style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:13.9849px;font-family:Arial;-inkscape-font-specification:'Arial Bold';text-align:center;text-anchor:middle;stroke-width:0.952601">XG2</tspan></text>
      </g>
    </g>
  </g>
  <g
     inkscape:groupmode="layer"
     id="layer2"
     inkscape:label="??? 2"
     style="display:none"
     sodipodi:insensitive="true">
    <g
       inkscape:groupmode="layer"
       id="layer8"
       inkscape:label="??? 5"
       style="display:none"
       sodipodi:insensitive="true">
      <g
         id="g135851"
         style="display:inline;stroke:#000000;stroke-opacity:1">
        <rect
           style="opacity:1;fill:#ffd700;fill-opacity:1;stroke:#000000;stroke-width:1.18487;stroke-opacity:1"
           id="rect22448"
           width="235"
           height="90"
           x="19.999878"
           y="10"
           rx="4.4523811"
           ry="7.4646063" />
        <rect
           style="opacity:1;fill:#ffd700;fill-opacity:1;stroke:#000000;stroke-width:1.22631;stroke-opacity:1"
           id="rect22558"
           width="765.02484"
           height="90"
           x="262.48755"
           y="10"
           rx="5.2022676"
           ry="7.6148057" />
        <rect
           style="opacity:1;fill:#ffd700;fill-opacity:1;stroke:#000000;stroke-width:1.13175;stroke-opacity:1"
           id="rect22410"
           width="133.02155"
           height="90"
           x="1035.0001"
           y="10"
           rx="4.8595533"
           ry="6.9429116" />
      </g>
    </g>
    <g
       inkscape:groupmode="layer"
       id="layer7"
       inkscape:label="??? 4"
       style="display:none"
       sodipodi:insensitive="true">
      <rect
         style="display:inline;opacity:1;fill:#9acd32;fill-opacity:1;stroke-width:0.981267"
         id="rect22412"
         width="100"
         height="90"
         x="30"
         y="10"
         rx="3.6532075"
         ry="6.9429116" />
      <rect
         style="display:inline;opacity:1;fill:#9acd32;fill-opacity:1;stroke-width:0.981267"
         id="rect22424"
         width="100"
         height="90"
         x="145"
         y="10"
         rx="3.6532075"
         ry="6.9429116" />
      <rect
         style="display:inline;opacity:1;fill:#9acd32;fill-opacity:1;stroke-width:1.38997"
         id="rect22705"
         width="70"
         height="90"
         x="264.48801"
         y="10"
         rx="5.1060309"
         ry="7.4646063" />
      <rect
         style="display:inline;opacity:1;fill:#9acd32;fill-opacity:1;stroke-width:1.02916"
         id="rect22328"
         width="110"
         height="90"
         x="335.54178"
         y="10"
         rx="4.0185285"
         ry="6.9429116" />
      <rect
         style="display:inline;opacity:1;fill:#9acd32;fill-opacity:1;stroke-width:1.02916"
         id="rect22414"
         width="110"
         height="90"
         x="447.38416"
         y="10"
         rx="4.0185285"
         ry="6.9429116" />
      <rect
         style="display:inline;opacity:1;fill:#9acd32;fill-opacity:1;stroke-width:1.02916"
         id="rect22416"
         width="110"
         height="90"
         x="559.22656"
         y="10"
         rx="4.0185285"
         ry="6.9429116" />
      <rect
         style="display:inline;opacity:1;fill:#9acd32;fill-opacity:1;stroke-width:1.02916"
         id="rect22787"
         width="110"
         height="90"
         x="671.06897"
         y="10"
         rx="4.0185285"
         ry="6.9429116" />
      <rect
         style="display:inline;opacity:1;fill:#9acd32;fill-opacity:1;stroke-width:0.930912"
         id="rect22418"
         width="90"
         height="90"
         x="782.91138"
         y="10"
         rx="3.2878866"
         ry="6.9429116" />
      <rect
         style="display:inline;opacity:1;fill:#9acd32;fill-opacity:1;stroke-width:0.930913"
         width="90"
         height="90"
         x="874.75378"
         y="10"
         rx="3.2878866"
         ry="6.9429135"
         id="rect144447" />
      <rect
         style="display:inline;opacity:1;fill:#9acd32;fill-opacity:1;stroke-width:0.760088"
         id="rect22420"
         width="60"
         height="90"
         x="966.59619"
         y="10"
         rx="2.1919246"
         ry="6.9429135" />
      <rect
         style="display:inline;opacity:1;fill:#9acd32;fill-opacity:1;stroke-width:1.07492"
         id="rect135541"
         width="120"
         height="90"
         x="1037"
         y="10"
         rx="4.3838491"
         ry="6.9429116" />
    </g>
  </g>
  <g
     inkscape:groupmode="layer"
     id="layer9"
     inkscape:label="??? 0"
     style="display:none"
     sodipodi:insensitive="true">
    <g
       id="g158244"
       transform="matrix(1,0,0,0.96956402,-11.017916,155.07432)"
       style="display:inline">
      <g
         transform="matrix(0.79509878,0,0,0.90964944,-280.0407,-151.70782)"
         id="g151444">
        <path
           style="fill:#000000;stroke:none;stroke-width:1.19203px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
           d="m 732.44718,25.969512 v -1.530273 h 9.95659 v 1.530273 h 2.96709 v 3.7207 h 6.03073 V 46.439239 H 723.44925 V 29.690212 h 6.03072 v -3.7207 z"
           id="path151426"
           sodipodi:nodetypes="ccccccccccccc" />
        <g
           transform="matrix(0.59709788,0,-0.15930534,0.39294624,394.6375,112.59546)"
           style="fill:#a0522d"
           id="g151442">
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-672.01849"
             y="-601.27802"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151428" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-666.02808"
             y="-597.6001"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151430" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-678.00891"
             y="-604.95593"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151432" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-689.98969"
             y="-612.31177"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151434" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-701.97052"
             y="-619.6676"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151436" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-683.99927"
             y="-608.63385"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151438" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-695.9801"
             y="-615.98969"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151440" />
        </g>
      </g>
      <g
         id="g151464"
         transform="matrix(0.79509878,0,0,0.90964944,-280.0407,-143.06593)">
        <path
           style="fill:#000000;stroke:none;stroke-width:1.19203px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
           d="M 732.44718,73.908527 V 75.4388 h 9.95659 v -1.530273 h 2.96709 v -3.7207 h 6.03073 V 53.4388 h -27.95234 v 16.749027 h 6.03072 v 3.7207 z"
           id="path151446"
           sodipodi:nodetypes="ccccccccccccc" />
        <g
           id="g151462"
           transform="matrix(-0.59709788,0,0.15930534,0.39294624,1080.2133,129.4208)"
           style="fill:#a0522d">
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151448"
             width="1.0511378"
             height="16.163235"
             x="-672.01849"
             y="-601.27802"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151450"
             width="1.0511378"
             height="16.163235"
             x="-666.02808"
             y="-597.6001"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151452"
             width="1.0511378"
             height="16.163235"
             x="-678.00891"
             y="-604.95593"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151454"
             width="1.0511378"
             height="16.163235"
             x="-689.98969"
             y="-612.31177"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151456"
             width="1.0511378"
             height="16.163235"
             x="-701.97052"
             y="-619.6676"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151458"
             width="1.0511378"
             height="16.163235"
             x="-683.99927"
             y="-608.63385"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151460"
             width="1.0511378"
             height="16.163235"
             x="-695.9801"
             y="-615.98969"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
        </g>
      </g>
      <g
         id="g151488"
         transform="matrix(0.21200342,0,0,0.2507292,174.1754,-71.265888)"
         name="g0/1">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151484"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151486"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         id="g151494"
         transform="matrix(0.21200342,0,0,-0.2507292,174.1754,-133.69511)"
         name="g0/2">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151490"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151492"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         id="g151518"
         transform="matrix(0.21200342,0,0,0.2507292,230.18496,-71.265888)"
         name="g0/3">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151514"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151516"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         id="g151524"
         transform="matrix(0.21200342,0,0,-0.2507292,230.18496,-133.69511)"
         name="g0/4">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151520"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151522"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         id="g151550"
         transform="matrix(0.21200342,0,0,0.2507292,286.00896,-71.265888)"
         name="g0/5">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151546"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151548"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         id="g151556"
         transform="matrix(0.21200342,0,0,-0.2507292,286.00896,-133.69511)"
         name="g0/6">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151552"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151554"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         id="g151580"
         transform="matrix(0.21200342,0,0,0.2507292,342.01852,-71.265888)"
         name="g0/7">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151576"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151578"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         id="g151586"
         transform="matrix(0.21200342,0,0,-0.2507292,342.01852,-133.69511)"
         name="g0/8">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151582"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151584"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         id="g151612"
         transform="matrix(0.21200342,0,0,0.2507292,397.85196,-71.265888)"
         name="g0/9">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151608"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151610"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         id="g151618"
         transform="matrix(0.21200342,0,0,-0.2507292,397.85196,-133.69511)"
         name="g0/10">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151614"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151616"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         id="g151642"
         transform="matrix(0.21200342,0,0,0.2507292,453.86152,-71.265888)"
         name="g0/11">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151638"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151640"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         id="g151648"
         transform="matrix(0.21200342,0,0,-0.2507292,453.86152,-133.69511)"
         name="g0/12">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151644"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151646"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         id="g151674"
         transform="matrix(0.21200342,0,0,0.2507292,509.69396,-71.265888)"
         name="g0/13">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151670"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151672"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         id="g151680"
         transform="matrix(0.21200342,0,0,-0.2507292,509.69396,-133.69511)"
         name="g0/14">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151676"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151678"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         id="g151704"
         transform="matrix(0.21200342,0,0,0.2507292,565.70352,-71.265888)"
         name="g0/15">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151700"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151702"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         id="g151710"
         transform="matrix(0.21200342,0,0,-0.2507292,565.70352,-133.69511)"
         name="g0/16">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151706"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151708"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         id="g151736"
         transform="matrix(0.21509589,0,0,0.25082272,618.98589,-71.510636)"
         name="e1/1_sfp">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151732"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151734"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         id="g151742"
         transform="matrix(0.21509589,0,0,-0.25082272,618.98589,-133.96314)"
         name="e1/2_sfp">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151738"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151740"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         transform="matrix(0.79510497,0,0,0.90964944,261.79859,-152.48486)"
         id="g151766"
         name="e1/1">
        <path
           style="fill:#000000;stroke:none;stroke-width:1.19203px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
           d="m 732.44718,25.969512 v -1.530273 h 9.95659 v 1.530273 h 2.96709 v 3.7207 h 6.03073 V 46.439239 H 723.44925 V 29.690212 h 6.03072 v -3.7207 z"
           id="path151748"
           sodipodi:nodetypes="ccccccccccccc" />
        <g
           transform="matrix(0.59709788,0,-0.15930534,0.39294624,394.6375,112.59546)"
           style="fill:#a0522d"
           id="g151764">
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-672.01849"
             y="-601.27802"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151750" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-666.02808"
             y="-597.6001"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151752" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-678.00891"
             y="-604.95593"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151754" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-689.98969"
             y="-612.31177"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151756" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-701.97052"
             y="-619.6676"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151758" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-683.99927"
             y="-608.63385"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151760" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-695.9801"
             y="-615.98969"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151762" />
        </g>
      </g>
      <g
         id="g151786"
         transform="matrix(0.79510497,0,0,0.90964944,261.79859,-143.84297)"
         name="e1/2">
        <path
           style="fill:#000000;stroke:none;stroke-width:1.19203px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
           d="M 732.44718,73.908527 V 75.4388 h 9.95659 v -1.530273 h 2.96709 v -3.7207 h 6.03073 V 53.4388 h -27.95234 v 16.749027 h 6.03072 v 3.7207 z"
           id="path151768"
           sodipodi:nodetypes="ccccccccccccc" />
        <g
           id="g151784"
           transform="matrix(-0.59709788,0,0.15930534,0.39294624,1080.2133,129.4208)"
           style="fill:#a0522d">
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151770"
             width="1.0511378"
             height="16.163235"
             x="-672.01849"
             y="-601.27802"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151772"
             width="1.0511378"
             height="16.163235"
             x="-666.02808"
             y="-597.6001"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151774"
             width="1.0511378"
             height="16.163235"
             x="-678.00891"
             y="-604.95593"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151776"
             width="1.0511378"
             height="16.163235"
             x="-689.98969"
             y="-612.31177"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151778"
             width="1.0511378"
             height="16.163235"
             x="-701.97052"
             y="-619.6676"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151780"
             width="1.0511378"
             height="16.163235"
             x="-683.99927"
             y="-608.63385"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151782"
             width="1.0511378"
             height="16.163235"
             x="-695.9801"
             y="-615.98969"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
        </g>
      </g>
      <g
         id="g151810"
         transform="matrix(0.21509589,0,0,0.25082272,710.82889,-71.510636)"
         name="e1/3_sfp">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151806"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151808"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         id="g151816"
         transform="matrix(0.21509589,0,0,-0.25082272,710.82889,-133.96314)"
         name="e1/4_sfp">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151812"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151814"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         transform="matrix(0.79510497,0,0,0.90964944,353.64159,-152.48486)"
         id="g151840"
         name="e1/3">
        <path
           style="fill:#000000;stroke:none;stroke-width:1.19203px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
           d="m 732.44718,25.969512 v -1.530273 h 9.95659 v 1.530273 h 2.96709 v 3.7207 h 6.03073 V 46.439239 H 723.44925 V 29.690212 h 6.03072 v -3.7207 z"
           id="path151822"
           sodipodi:nodetypes="ccccccccccccc" />
        <g
           transform="matrix(0.59709788,0,-0.15930534,0.39294624,394.6375,112.59546)"
           style="fill:#a0522d"
           id="g151838">
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-672.01849"
             y="-601.27802"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151824" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-666.02808"
             y="-597.6001"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151826" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-678.00891"
             y="-604.95593"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151828" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-689.98969"
             y="-612.31177"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151830" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-701.97052"
             y="-619.6676"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151832" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-683.99927"
             y="-608.63385"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151834" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             width="1.0511378"
             height="16.163235"
             x="-695.9801"
             y="-615.98969"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)"
             id="rect151836" />
        </g>
      </g>
      <g
         id="g151860"
         transform="matrix(0.79510497,0,0,0.90964944,353.64159,-143.84297)"
         name="e1/4">
        <path
           style="fill:#000000;stroke:none;stroke-width:1.19203px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
           d="M 732.44718,73.908527 V 75.4388 h 9.95659 v -1.530273 h 2.96709 v -3.7207 h 6.03073 V 53.4388 h -27.95234 v 16.749027 h 6.03072 v 3.7207 z"
           id="path151842"
           sodipodi:nodetypes="ccccccccccccc" />
        <g
           id="g151858"
           transform="matrix(-0.59709788,0,0.15930534,0.39294624,1080.2133,129.4208)"
           style="fill:#a0522d">
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151844"
             width="1.0511378"
             height="16.163235"
             x="-672.01849"
             y="-601.27802"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151846"
             width="1.0511378"
             height="16.163235"
             x="-666.02808"
             y="-597.6001"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151848"
             width="1.0511378"
             height="16.163235"
             x="-678.00891"
             y="-604.95593"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151850"
             width="1.0511378"
             height="16.163235"
             x="-689.98969"
             y="-612.31177"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151852"
             width="1.0511378"
             height="16.163235"
             x="-701.97052"
             y="-619.6676"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151854"
             width="1.0511378"
             height="16.163235"
             x="-683.99927"
             y="-608.63385"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
          <rect
             style="fill:#a0522d;fill-opacity:0.95;stroke:#ff0000;stroke-width:0.0677424;stroke-opacity:1"
             id="rect151856"
             width="1.0511378"
             height="16.163235"
             x="-695.9801"
             y="-615.98969"
             rx="0.11332455"
             ry="1.0626545"
             transform="matrix(-0.78945565,-0.61380761,0.02287757,0.99973827,0,0)" />
        </g>
      </g>
      <g
         id="g151884"
         transform="matrix(0.21200342,0,0,0.2507292,805.22096,-71.265888)"
         name="e2/1">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151880"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151882"
           sodipodi:nodetypes="ccccc" />
      </g>
      <g
         id="g151890"
         transform="matrix(0.21200342,0,0,-0.2507292,805.22096,-133.69511)"
         name="e2/2">
        <path
           style="color:#000000;fill:#000000;stroke-width:1.48803;-inkscape-stroke:none"
           d="M 972.60963,-232.40442 H 834.38095 l -3e-4,75.2347 h 42.0763 v 9.45467 h 54.07594 v -9.45467 h 42.07639 z"
           id="path151886"
           sodipodi:nodetypes="ccccccccc" />
        <path
           style="color:#000000;fill:#d3d3d3;stroke-width:0.325352;-inkscape-stroke:none"
           d="m 880.49514,-159.87853 h 46 l -1.00947,4.5 h -43.98122 z"
           id="path151888"
           sodipodi:nodetypes="ccccc" />
      </g>
    </g>
  </g>
  <g
     inkscape:groupmode="layer"
     id="layer10"
     inkscape:label="??? 6"
     style="display:inline">
    <g
       id="power1"
       transform="translate(3.9703532)"
       name="power1">
      <g
         id="g114640"
         transform="matrix(0.80597366,0,0,0.80597366,124.50365,95.199999)">
        <circle
           style="opacity:1;fill:#808080;fill-opacity:0.94902;stroke:none;stroke-width:1.47059;stroke-opacity:1"
           id="circle114636"
           cx="-18.114737"
           cy="-49.87756"
           r="6.2036767" />
        <circle
           style="opacity:1;fill:#00ff00;fill-opacity:0.94902;stroke:none;stroke-width:1.31579;stroke-opacity:1"
           id="circle114638"
           cx="-18.114737"
           cy="-49.87756"
           r="4.8976398"
           name="led_power1" />
      </g>
      <g
         id="g114789">
        <path
           style="color:#000000;fill:#555555;stroke-width:0.936924;-inkscape-stroke:none"
           d="m 47.323344,25.000002 h 43.69369 c 1.746848,0 3.153155,1.49856 3.153155,3.360001 v 53.279998 c 0,1.86144 -1.406307,3.360001 -3.153155,3.360001 h -43.69369 c -1.746848,0 -3.153155,-1.498561 -3.153155,-3.360001 V 28.360003 c 0,-1.861441 1.406307,-3.360001 3.153155,-3.360001 z"
           id="path134969" />
        <path
           id="path114779"
           style="fill:#333333;fill-opacity:1;stroke-width:0.80959"
           d="m 53.566908,30.206719 h 24.380585 l 9.026215,9.130301 V 70.662999 L 77.947493,79.7933 H 53.566908 L 51.366665,77.195033 V 33.355765 Z"
           sodipodi:nodetypes="ccccccccc" />
        <g
           id="g114787"
           transform="matrix(1.1319856,0,0,1.1097838,-116.93794,138.19393)"
           style="fill:#cccccc;fill-opacity:1">
          <path
             id="path114781"
             style="opacity:1;fill:#cccccc;fill-opacity:1;stroke-width:0.0971915"
             d="m 166.79274,-76.618187 -2.00777,1.102739 0.0293,1.10274 2.09596,1.10274 h 5.94483 l 2.09581,-1.10274 0.0294,-1.10274 -2.00777,-1.102739 z"
             sodipodi:nodetypes="ccccccccc" />
          <path
             id="path114783"
             style="opacity:1;fill:#cccccc;fill-opacity:1;stroke-width:0.0971915"
             d="m 155.84462,-64.70713 -2.00777,1.102739 0.0293,1.10274 2.09596,1.10274 h 5.94484 l 2.0958,-1.10274 0.0295,-1.10274 -2.00777,-1.102739 z"
             sodipodi:nodetypes="ccccccccc" />
          <path
             id="path114785"
             style="opacity:1;fill:#cccccc;fill-opacity:1;stroke-width:0.0971915"
             d="m 155.84462,-88.529243 -2.00777,1.102739 0.0293,1.102739 2.09596,1.10274 h 5.94484 l 2.0958,-1.10274 0.0295,-1.102739 -2.00777,-1.102739 z"
             sodipodi:nodetypes="ccccccccc" />
        </g>
      </g>
    </g>
    <g
       id="power2"
       transform="translate(120)"
       name="power2">
      <g
         id="g115015"
         transform="matrix(0.80597366,0,0,0.80597366,124.50365,95.199999)">
        <circle
           style="opacity:1;fill:#808080;fill-opacity:0.94902;stroke:none;stroke-width:1.47059;stroke-opacity:1"
           id="circle115011"
           cx="-18.114737"
           cy="-49.87756"
           r="6.2036767" />
        <circle
           style="opacity:1;fill:#00ff00;fill-opacity:0.94902;stroke:none;stroke-width:1.31579;stroke-opacity:1"
           id="circle115013"
           cx="-18.114737"
           cy="-49.87756"
           r="4.8976398"
           name="led_power2" />
      </g>
      <g
         id="g115029">
        <path
           id="rect115017"
           style="fill:#555555;stroke-width:0.936924"
           d="m 47.323344,25.000002 h 43.69369 c 1.746848,0 3.153155,1.49856 3.153155,3.360001 v 53.279998 c 0,1.86144 -1.406307,3.360001 -3.153155,3.360001 h -43.69369 c -1.746848,0 -3.153155,-1.498561 -3.153155,-3.360001 V 28.360003 c 0,-1.861441 1.406307,-3.360001 3.153155,-3.360001 z" />
        <path
           id="path115019"
           style="fill:#333333;fill-opacity:1;stroke-width:0.80959"
           d="m 53.566908,30.206719 h 24.380585 l 9.026215,9.130301 V 70.662999 L 77.947493,79.7933 H 53.566908 L 51.366665,77.195033 V 33.355765 Z"
           sodipodi:nodetypes="ccccccccc" />
        <g
           id="g115027"
           transform="matrix(1.1319856,0,0,1.1097838,-116.93794,138.19393)"
           style="fill:#cccccc;fill-opacity:1">
          <path
             id="path115021"
             style="opacity:1;fill:#cccccc;fill-opacity:1;stroke-width:0.0971915"
             d="m 166.79274,-76.618187 -2.00777,1.102739 0.0293,1.10274 2.09596,1.10274 h 5.94483 l 2.09581,-1.10274 0.0294,-1.10274 -2.00777,-1.102739 z"
             sodipodi:nodetypes="ccccccccc" />
          <path
             id="path115023"
             style="opacity:1;fill:#cccccc;fill-opacity:1;stroke-width:0.0971915"
             d="m 155.84462,-64.70713 -2.00777,1.102739 0.0293,1.10274 2.09596,1.10274 h 5.94484 l 2.0958,-1.10274 0.0295,-1.10274 -2.00777,-1.102739 z"
             sodipodi:nodetypes="ccccccccc" />
          <path
             id="path115025"
             style="opacity:1;fill:#cccccc;fill-opacity:1;stroke-width:0.0971915"
             d="m 155.84462,-88.529243 -2.00777,1.102739 0.0293,1.102739 2.09596,1.10274 h 5.94484 l 2.0958,-1.10274 0.0295,-1.102739 -2.00777,-1.102739 z"
             sodipodi:nodetypes="ccccccccc" />
        </g>
      </g>
    </g>
    <g
       id="fan"
       name="fan"
       transform="translate(72,182.25949)">
      <g
         id="g133268"
         transform="translate(-2.1055978,15.265583)">
        <circle
           style="fill:#222222;fill-opacity:1;stroke:none;stroke-width:0.330281;stroke-opacity:1"
           id="circle126176"
           cx="1011.6152"
           cy="-142.52507"
           r="25" />
        <g
           id="g133080"
           transform="matrix(1.1740503,0,0,1.1740503,-364.42411,59.503471)">
          <g
             id="g132991"
             transform="matrix(-0.02262528,-0.01746882,-0.03827341,0.02731691,1165.4079,-136.39087)"
             inkscape:transform-center-x="0.030591067"
             inkscape:transform-center-y="13.237163">
            <path
               style="fill:#555555;fill-opacity:1;stroke-width:1.21421"
               d="m 812.42891,-557.9172 c -18.79054,0.22814 -30.85973,-1.96087 -43.55549,-5.61239 0,0 -44.46443,-13.93587 -83.85958,-47.36287 -183.34257,107.19256 -439.8038,134.9719 -462.64851,135.36375 -29.88711,0.51265 -0.86727,28.431 -0.86727,28.431 22.65133,32.53208 121.37714,105.87658 162.83333,121.50225 45.42834,17.12285 75.17839,21.55569 115.84424,27.36125 199.98574,-100.09964 288.15803,-225.7402 312.25328,-259.68299 z"
               id="path132987"
               sodipodi:nodetypes="cccscccc" />
            <path
               id="path132989"
               style="fill:#444444;fill-opacity:1;stroke-width:1.21421"
               d="m 384.33139,-325.59602 c 72.28908,-20.00999 277.1312,-124.62473 384.54085,-237.9332 12.69575,3.65152 24.76539,5.83956 43.55593,5.61142 -24.09525,33.94279 -112.26661,159.58393 -312.25237,259.68357 -40.66583,-5.80556 -70.41607,-10.23894 -115.84441,-27.36179 z"
               sodipodi:nodetypes="ccccc" />
          </g>
          <g
             id="g133027"
             transform="matrix(-4.4874412e-4,-0.02858079,-0.0452202,-0.01289188,1140.0158,-155.057)"
             inkscape:transform-center-x="11.786627"
             inkscape:transform-center-y="9.056642">
            <path
               style="fill:#555555;fill-opacity:1;stroke-width:1.21421"
               d="m 812.42891,-557.9172 c -18.79054,0.22814 -30.85973,-1.96087 -43.55549,-5.61239 0,0 -44.46443,-13.93587 -83.85958,-47.36287 -183.34257,107.19256 -439.8038,134.9719 -462.64851,135.36375 -29.88711,0.51265 -0.86727,28.431 -0.86727,28.431 22.65133,32.53208 121.37714,105.87658 162.83333,121.50225 45.42834,17.12285 75.17839,21.55569 115.84424,27.36125 199.98574,-100.09964 288.15803,-225.7402 312.25328,-259.68299 z"
               id="path133023"
               sodipodi:nodetypes="cccscccc" />
            <path
               id="path133025"
               style="fill:#444444;fill-opacity:1;stroke-width:1.21421"
               d="m 384.33139,-325.59602 c 72.28908,-20.00999 277.1312,-124.62473 384.54085,-237.9332 12.69575,3.65152 24.76539,5.83956 43.55593,5.61142 -24.09525,33.94279 -112.26661,159.58393 -312.25237,259.68357 -40.66583,-5.80556 -70.41607,-10.23894 -115.84441,-27.36179 z"
               sodipodi:nodetypes="ccccc" />
          </g>
          <g
             id="g133033"
             transform="matrix(0.02206571,-0.01817051,-0.01811473,-0.04339267,1138.778,-186.54749)"
             inkscape:transform-center-x="12.80954"
             inkscape:transform-center-y="-4.18812">
            <path
               style="fill:#555555;fill-opacity:1;stroke-width:1.21421"
               d="m 812.42891,-557.9172 c -18.79054,0.22814 -30.85973,-1.96087 -43.55549,-5.61239 0,0 -44.46443,-13.93587 -83.85958,-47.36287 -183.34257,107.19256 -439.8038,134.9719 -462.64851,135.36375 -29.88711,0.51265 -0.86727,28.431 -0.86727,28.431 22.65133,32.53208 121.37714,105.87658 162.83333,121.50225 45.42834,17.12285 75.17839,21.55569 115.84424,27.36125 199.98574,-100.09964 288.15803,-225.7402 312.25328,-259.68299 z"
               id="path133029"
               sodipodi:nodetypes="cccscccc" />
            <path
               id="path133031"
               style="fill:#444444;fill-opacity:1;stroke-width:1.21421"
               d="m 384.33139,-325.59602 c 72.28908,-20.00999 277.1312,-124.62473 384.54085,-237.9332 12.69575,3.65152 24.76539,5.83956 43.55593,5.61142 -24.09525,33.94279 -112.26661,159.58393 -312.25237,259.68357 -40.66583,-5.80556 -70.41607,-10.23894 -115.84441,-27.36179 z"
               sodipodi:nodetypes="ccccc" />
          </g>
          <g
             id="g133039"
             transform="matrix(0.02796398,0.00592275,0.02263171,-0.04121738,1162.6267,-207.14906)"
             inkscape:transform-center-x="6.7873075"
             inkscape:transform-center-y="-12.816073">
            <path
               style="fill:#555555;fill-opacity:1;stroke-width:1.21421"
               d="m 812.42891,-557.9172 c -18.79054,0.22814 -30.85973,-1.96087 -43.55549,-5.61239 0,0 -44.46443,-13.93587 -83.85958,-47.36287 -183.34257,107.19256 -439.8038,134.9719 -462.64851,135.36375 -29.88711,0.51265 -0.86727,28.431 -0.86727,28.431 22.65133,32.53208 121.37714,105.87658 162.83333,121.50225 45.42834,17.12285 75.17839,21.55569 115.84424,27.36125 199.98574,-100.09964 288.15803,-225.7402 312.25328,-259.68299 z"
               id="path133035"
               sodipodi:nodetypes="cccscccc" />
            <path
               id="path133037"
               style="fill:#444444;fill-opacity:1;stroke-width:1.21421"
               d="m 384.33139,-325.59602 c 72.28908,-20.00999 277.1312,-124.62473 384.54085,-237.9332 12.69575,3.65152 24.76539,5.83956 43.55593,5.61142 -24.09525,33.94279 -112.26661,159.58393 -312.25237,259.68357 -40.66583,-5.80556 -70.41607,-10.23894 -115.84441,-27.36179 z"
               sodipodi:nodetypes="ccccc" />
          </g>
          <g
             id="g133045"
             transform="matrix(0.01280447,0.02555599,0.04633575,-0.00800409,1193.603,-201.34804)"
             inkscape:transform-center-x="-8.0363804"
             inkscape:transform-center-y="-12.112542">
            <path
               style="fill:#555555;fill-opacity:1;stroke-width:1.21421"
               d="m 812.42891,-557.9172 c -18.79054,0.22814 -30.85973,-1.96087 -43.55549,-5.61239 0,0 -44.46443,-13.93587 -83.85958,-47.36287 -183.34257,107.19256 -439.8038,134.9719 -462.64851,135.36375 -29.88711,0.51265 -0.86727,28.431 -0.86727,28.431 22.65133,32.53208 121.37714,105.87658 162.83333,121.50225 45.42834,17.12285 75.17839,21.55569 115.84424,27.36125 199.98574,-100.09964 288.15803,-225.7402 312.25328,-259.68299 z"
               id="path133041"
               sodipodi:nodetypes="cccscccc" />
            <path
               id="path133043"
               style="fill:#444444;fill-opacity:1;stroke-width:1.21421"
               d="m 384.33139,-325.59602 c 72.28908,-20.00999 277.1312,-124.62473 384.54085,-237.9332 12.69575,3.65152 24.76539,5.83956 43.55593,5.61142 -24.09525,33.94279 -112.26661,159.58393 -312.25237,259.68357 -40.66583,-5.80556 -70.41607,-10.23894 -115.84441,-27.36179 z"
               sodipodi:nodetypes="ccccc" />
          </g>
          <g
             id="g133051"
             transform="matrix(-0.01199722,0.02594475,0.03514748,0.03123654,1208.3808,-173.5128)"
             inkscape:transform-center-x="-13.421488"
             inkscape:transform-center-y="-3.7294016">
            <path
               style="fill:#555555;fill-opacity:1;stroke-width:1.21421"
               d="m 812.42891,-557.9172 c -18.79054,0.22814 -30.85973,-1.96087 -43.55549,-5.61239 0,0 -44.46443,-13.93587 -83.85958,-47.36287 -183.34257,107.19256 -439.8038,134.9719 -462.64851,135.36375 -29.88711,0.51265 -0.86727,28.431 -0.86727,28.431 22.65133,32.53208 121.37714,105.87658 162.83333,121.50225 45.42834,17.12285 75.17839,21.55569 115.84424,27.36125 199.98574,-100.09964 288.15803,-225.7402 312.25328,-259.68299 z"
               id="path133047"
               sodipodi:nodetypes="cccscccc" />
            <path
               id="path133049"
               style="fill:#444444;fill-opacity:1;stroke-width:1.21421"
               d="m 384.33139,-325.59602 c 72.28908,-20.00999 277.1312,-124.62473 384.54085,-237.9332 12.69575,3.65152 24.76539,5.83956 43.55593,5.61142 -24.09525,33.94279 -112.26661,159.58393 -312.25237,259.68357 -40.66583,-5.80556 -70.41607,-10.23894 -115.84441,-27.36179 z"
               sodipodi:nodetypes="ccccc" />
          </g>
          <g
             id="g133057"
             transform="matrix(-0.02776462,0.00679628,-0.00250797,0.04695505,1195.8319,-144.60416)"
             inkscape:transform-center-x="-10.84873"
             inkscape:transform-center-y="10.166584">
            <path
               style="fill:#555555;fill-opacity:1;stroke-width:1.21421"
               d="m 812.42891,-557.9172 c -18.79054,0.22814 -30.85973,-1.96087 -43.55549,-5.61239 0,0 -44.46443,-13.93587 -83.85958,-47.36287 -183.34257,107.19256 -439.8038,134.9719 -462.64851,135.36375 -29.88711,0.51265 -0.86727,28.431 -0.86727,28.431 22.65133,32.53208 121.37714,105.87658 162.83333,121.50225 45.42834,17.12285 75.17839,21.55569 115.84424,27.36125 199.98574,-100.09964 288.15803,-225.7402 312.25328,-259.68299 z"
               id="path133053"
               sodipodi:nodetypes="cccscccc" />
            <path
               id="path133055"
               style="fill:#444444;fill-opacity:1;stroke-width:1.21421"
               d="m 384.33139,-325.59602 c 72.28908,-20.00999 277.1312,-124.62473 384.54085,-237.9332 12.69575,3.65152 24.76539,5.83956 43.55593,5.61142 -24.09525,33.94279 -112.26661,159.58393 -312.25237,259.68357 -40.66583,-5.80556 -70.41607,-10.23894 -115.84441,-27.36179 z"
               sodipodi:nodetypes="ccccc" />
          </g>
        </g>
        <circle
           style="fill:#555555;fill-opacity:1;stroke:none;stroke-width:0.156384;stroke-opacity:1"
           id="circle126236"
           cx="1011.6152"
           cy="-142.52507"
           r="9.438776" />
        <circle
           style="fill:#444444;fill-opacity:1;stroke:none;stroke-width:0.26846;stroke-opacity:1"
           id="circle126238"
           cx="1011.6152"
           cy="-142.52507"
           r="7.9688034" />
        <circle
           style="fill:#bbbbbb;fill-opacity:1;stroke:none;stroke-width:0.146073;stroke-opacity:1"
           id="circle126240"
           cx="1011.6152"
           cy="-142.52507"
           r="6.5761962" />
      </g>
      <g
         id="g126248"
         transform="matrix(0.80597366,0,0,0.80597366,1063.535,-87.059488)">
        <circle
           style="opacity:1;fill:#808080;fill-opacity:0.94902;stroke:none;stroke-width:1.47059;stroke-opacity:1"
           id="circle126244"
           cx="-18.114737"
           cy="-49.87756"
           r="6.2036767" />
        <circle
           style="opacity:1;fill:#00ff00;fill-opacity:0.94902;stroke:none;stroke-width:1.31579;stroke-opacity:1"
           id="circle126246"
           cx="-18.114737"
           cy="-49.87756"
           r="4.8976398"
           name="led_fan" />
      </g>
    </g>
  </g>
</svg>


</div>
</template>

<script>
export default {
  name: "panelSvg",
}
</script>
<style>
</style>
